/* ──────────────────────────────────────────────────────────────────
   src/pages/TermsAndConditions.jsx
   FluturoLire – Terms & Conditions (AL / EN / DE)
   -----------------------------------------------------------------*/

   import React, { Fragment, useEffect, useState } from "react";
   import { isMobile } from "react-device-detect";
   import { useTranslation } from "react-i18next";
   
   import Banner       from "../components/BannerNew";
   import Copyrights   from "../components/Copyrights";
   import Footer       from "../components/Footer";
   import Header       from "../components/Header";
   import Styles       from "../components/Styles";
   
   /* ---------- shared palette ---------- */
   const primaryColor = "#003663";
   const textStyles   = { color: primaryColor , };
   const headerTextStyle = { color: primaryColor, fontSize: "1rem", };
   const contentTextStyle = { color: primaryColor, fontSize: "1rem", lineHeight: "1.6" };
   

   const TermsAndConditionsPage = () => {
     const { t, i18n } = useTranslation();
   
     /* default → English */
     const [currentLang, setCurrentLang] = useState("en");
     useEffect(() => {
       const saved = localStorage.getItem("i18nextLng");
       if (saved) setCurrentLang(saved);
     }, []);
   
     const textAl = (
       <div style={{ ...textStyles, textAlign: "justify", padding: "20px" }}>
         <h1 style={{ textAlign: "left", marginBottom: "30px", fontWeight: "600" }}>
           Kushtet dhe Afatet për Shitjen Online të Biletave të Fluturimit dhe Akomodimit në Hotel
         </h1>
   
         <p style={{...contentTextStyle}}>
           Këto Kushte dhe Afate ("Marrëveshja") rregullojnë blerjen dhe përdorimin tuaj të shërbimeve të fluturimeve dhe hoteleve përmes FluturoLire L.L.C. ("Shitësi", "ne", "kompania") nëpërmjet faqes sonë të internetit dhe aplikacionit mobil (referuar si "Platforma"). Duke hyrë ose duke përdorur Platformën, ju pranoni të jeni të lidhur me këtë Marrëveshje dhe me Politikën tonë të Privatësisë.
         </p>
   
         <h4 style={{...headerTextStyle}}>{t("Company Information")}</h4>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C.<br />
           Nr. i Regjistrimit të Biznesit: 812101236<br />
           Adresa e Regjistruar: Bedri Berisha Nr.51 Prishtinë<br />
           Email Kontakti: info@fluturolire.com
         </p>
   
         <h4 style={{...headerTextStyle}}>1. Rezervimi dhe Pagesa</h4>
         <h5 style={{...headerTextStyle}}>1.1 Rezervimet e Udhëtimit</h5>
         <p style={{...contentTextStyle}}>
           Platforma ju lejon të kërkoni, krahasoni dhe rezervoni bileta fluturimi dhe akomodime në hotele. Të gjitha rezervimet varen nga disponueshmëria dhe i nënshtrohen kushteve specifike të linjave ajrore, hoteleve dhe ofruesve të tjerë të shërbimeve.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.2 Çmimet dhe Pagesa</h5>
         <p style={{...contentTextStyle}}>
           Çmimet janë dinamike dhe mund të ndryshojnë pa paralajmërim. Ato përfshijnë taksa dhe tarifa përveç rasteve kur tregohet ndryshe. Çmimet shfaqen në Euro (€). Me rezervimin, ju autorizoni FluturoLire L.L.C. të përpunojë pagesën në mënyrë të plotë përmes metodës suaj të përzgjedhur.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.3 Anulimet, Ndryshimet dhe Rimbursimet</h5>
         <p style={{...contentTextStyle}}>
           Politikat e anulimit dhe rimbursimit ndryshojnë sipas ofruesit dhe rregullave të tarifës. Disa bileta mund të jenë të pakthyeshme ose me tarifa shtesë. FluturoLire do t'ju ndihmojë në përpunimin e kërkesave, por mund të aplikohet tarifë shërbimi administrative, përveç tarifave të ofruesit.
         </p>
   
         <h4 style={{...headerTextStyle}}>2. Dokumentacioni dhe Kërkesat e Udhëtimit</h4>
         <h5 style={{...headerTextStyle}}>2.1 Dokumentet e Udhëtimit</h5>
         <p style={{...contentTextStyle}}>
           Ju jeni përgjegjës për posedimin e dokumenteve të nevojshme dhe të vlefshme si pasaporta, viza dhe certifikata shëndeti. Ne nuk mbajmë përgjegjësi për refuzim në bordin ose hyrje në destinacion.
         </p>
   
         <h5 style={{...headerTextStyle}}>2.2 Informacioni i Udhëtarit</h5>
         <p style={{...contentTextStyle}}>
           Ju duhet të siguroni informacione të sakta dhe të plota. Gabimet mund të shkaktojnë vonesa, kosto shtesë ose anulim.
         </p>
   
         <h4 style={{...headerTextStyle}}>3. Sjellja e Përdoruesit</h4>
         <h5 style={{...headerTextStyle}}>3.1 Aktivitetet e Ndaluara</h5>
         <p style={{...contentTextStyle}}>
           Nuk lejohet:<br />
           • Përdorimi i platformës për qëllime mashtruese ose të paligjshme<br />
           • Dëmtimi ose ndërhyrja në sistem<br />
           • Ngarkimi i përmbajtjeve të dëmshme ose viruseve<br />
           • Aksesimi pa autorizim në llogari ose sisteme të tjera
         </p>
   
         <h5 style={{...headerTextStyle}}>3.2 Paralajmërime Udhëtimi</h5>
         <p style={{...contentTextStyle}}>
           Ju jeni përgjegjës për ndjekjen e paralajmërimeve të udhëtimit dhe rregullave të hyrjes. Ne nuk mbajmë përgjegjësi për mosrespektimin tuaj.
         </p>
   
         <h4 style={{...headerTextStyle}}>4. Kufizimi i Përgjegjësisë</h4>
         <h5 style={{...headerTextStyle}}>4.1 Mohim Përgjegjësie</h5>
         <p style={{...contentTextStyle}}>
           FluturoLire vepron vetëm si ndërmjetës për ofrues të tretë. Ne nuk mbajmë përgjegjësi për gabime, ndryshime apo keqinformim nga ofruesit.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.2 Dëmshpërblim</h5>
         <p style={{...contentTextStyle}}>
           Ju pranoni të dëmshpërbleni FluturoLire për çdo kërkesë që lind nga përdorimi i platformës në kundërshtim me këtë marrëveshje.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.3 Kufizim Përgjegjësie</h5>
         <p style={{...contentTextStyle}}>
           Ne nuk mbajmë përgjegjësi për dëme të tërthorta, humbje fitimesh, të dhënash ose ndërprerje biznesi.
         </p>
   
         <h4 style={{...headerTextStyle}}>5. Raste të Jashtëzakonshme (Force Majeure)</h4>
         <p style={{...contentTextStyle}}>
           Ne nuk jemi përgjegjës për vonesa apo anulime të shkaktuara nga fatkeqësi natyrore, pandemi, luftëra, protesta ose rrethana jashtë kontrollit tonë.
         </p>
   
         <h4 style={{...headerTextStyle}}>6. Ndërprerja e Shërbimeve</h4>
         <p style={{...contentTextStyle}}>
           Ne mund të ndërpresim aksesin tuaj në platformë në çdo kohë. Ju gjithashtu mund të mbyllni llogarinë tuaj duke kontaktuar support@fluturolire.com.
         </p>
   
         <h4 style={{...headerTextStyle}}>7. Ndryshime</h4>
         <p style={{...contentTextStyle}}>
           Kushtet mund të ndryshojnë në çdo kohë. Përdorimi i mëtejshëm i platformës nënkupton pranimin e kushteve të reja.
         </p>
   
         <h4 style={{...headerTextStyle}}>8. Ligji në Fuqi</h4>
         <p style={{...contentTextStyle}}>
           Kjo Marrëveshje i nënshtrohet ligjeve të Republikës së Kosovës. Çdo mosmarrëveshje zgjidhet në gjykatat e Kosovës.
         </p>
   
         <h4 style={{...headerTextStyle}}>9. Ndashmëria</h4>
         <p style={{...contentTextStyle}}>
           Nëse një pjesë e Marrëveshjes është e pavlefshme, pjesa tjetër mbetet në fuqi.
         </p>
   
         <p style={{...contentTextStyle}}>
           Duke përdorur Platformën, ju pranoni këto Kushte dhe Afate.
         </p>
       </div>
     );
   
     /* ---------- English ---------- */
     const textEn = (
       <div style={{ ...textStyles, textAlign: "justify", padding: "20px" }}>
         <h1 style={{ textAlign: "left", marginBottom: "30px", fontWeight: "600" }}>
           Terms and Conditions for Online Sale of Flights and Hotels
         </h1>
   
         <p style={{...contentTextStyle}}>
           These Terms and Conditions (the "Agreement") govern your purchase and use of flight and hotel services through FluturoLire L.L.C. ("the Seller," "we," "us") via our website and mobile application (collectively referred to as the "Platform"). By accessing or using the Platform, you agree to be bound by this Agreement and by our Privacy Policy.
         </p>
   
         <h4 style={{...headerTextStyle}}>{t("Company Information")}</h4>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C.<br />
           Business Registration No: 812101236<br />
           Registered Address: Bedri Berisha Nr.51 Prishtinë<br />
           Contact Email: info@fluturolire.com
         </p>
   
         <h4 style={{...headerTextStyle}}>1. Booking and Payment</h4>
         <h5 style={{...headerTextStyle}}>1.1 Travel Bookings</h5>
         <p style={{...contentTextStyle}}>
           The Platform allows you to search, compare, and book flights and hotel accommodations. All bookings are subject to availability and governed by the specific terms and conditions of the respective airlines, hotels, and travel service providers.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.2 Pricing and Payment</h5>
         <p style={{...contentTextStyle}}>
           Prices displayed on the Platform are dynamic and may change without prior notice. Prices include applicable taxes and fees unless stated otherwise. Prices are displayed in Euro (€) unless otherwise indicated. All payments must be made using the available payment methods. By booking, you authorize FluturoLire L.L.C. to charge your selected payment method for the full amount due.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.3 Cancellations, Changes, and Refunds</h5>
         <p style={{...contentTextStyle}}>
           Cancellation, change, and refund policies vary by provider and fare rules. Some bookings may be non-refundable or may incur cancellation or modification fees set by airlines, hotels, or service providers. FluturoLire L.L.C. will assist you in processing cancellations, changes, or refunds according to the applicable provider's policy. Please note that FluturoLire L.L.C. may apply an administrative service fee in addition to any supplier-imposed fees.
         </p>
   
         <h4 style={{...headerTextStyle}}>2. Travel Documentation and Requirements</h4>
         <h5 style={{...headerTextStyle}}>2.1 Travel Documents</h5>
         <p style={{...contentTextStyle}}>
           You are solely responsible for ensuring that you possess all necessary and valid travel documents, including passports, visas, entry permits, and health certificates. FluturoLire L.L.C. assumes no liability for denied boarding, denied entry, or other issues arising from insufficient, invalid, or expired documentation.
         </p>
   
         <h5 style={{...headerTextStyle}}>2.2 Traveler Information</h5>
         <p style={{...contentTextStyle}}>
           You must provide accurate, complete, and up-to-date information during the booking process. Any errors in traveler information (such as misspelled names) may result in additional costs, denied boarding, or cancellation.
         </p>
   
         <h4 style={{...headerTextStyle}}>3. User Conduct</h4>
         <h5 style={{...headerTextStyle}}>3.1 Prohibited Activities</h5>
         <p style={{...contentTextStyle}}>
           You agree not to:<br />
           • Violate any applicable laws, regulations, or third-party rights<br />
           • Use the Platform for fraudulent, unlawful, or unauthorized purposes<br />
           • Interfere with the proper functioning of the Platform<br />
           • Upload or distribute viruses, malware, or harmful content<br />
           • Attempt to gain unauthorized access
         </p>
   
         <h5 style={{...headerTextStyle}}>3.2 Travel Advisories and Restrictions</h5>
         <p style={{...contentTextStyle}}>
           You are responsible for staying informed about travel advisories, health warnings, and entry requirements issued by authorities. FluturoLire L.L.C. bears no responsibility for consequences resulting from your failure to comply with travel restrictions or advisories.
         </p>
   
         <h4 style={{...headerTextStyle}}>4. Limitation of Liability</h4>
         <h5 style={{...headerTextStyle}}>4.1 Disclaimer</h5>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C. acts solely as an agent for third-party airlines, hotels, and service providers. We do not guarantee the accuracy, availability, or reliability of information such as schedules, prices, or descriptions displayed on the Platform.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.2 Indemnification</h5>
         <p style={{...contentTextStyle}}>
           You agree to indemnify, defend, and hold harmless FluturoLire L.L.C., its affiliates, directors, employees, and agents from any claims, damages, liabilities, costs, or expenses arising from your use of the Platform.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.3 Limitation of Liability</h5>
         <p style={{...contentTextStyle}}>
           To the maximum extent permitted by applicable law, FluturoLire L.L.C. shall not be liable for any indirect, incidental, special, consequential, or punitive damages.
         </p>
   
         <h4 style={{...headerTextStyle}}>5. Force Majeure</h4>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C. is not liable for any delay, change, or cancellation of travel services due to events beyond our control ("Force Majeure Events"), including but not limited to natural disasters, wars, terrorism, pandemics, labor strikes, government restrictions, or other unforeseen circumstances.
         </p>
   
         <h4 style={{...headerTextStyle}}>6. Termination</h4>
         <p style={{...contentTextStyle}}>
           We may suspend or terminate your access to the Platform at any time. You may terminate your account by contacting support@fluturolire.com.
         </p>
   
         <h4 style={{...headerTextStyle}}>7. Amendments</h4>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C. reserves the right to amend or update these Terms and Conditions at any time. Continued use of the Platform after such changes constitutes your acceptance.
         </p>
   
         <h4 style={{...headerTextStyle}}>8. Governing Law and Dispute Resolution</h4>
         <p style={{...contentTextStyle}}>
           This Agreement shall be governed by and construed under the laws of the Republic of Kosovo. Any disputes shall be subject to the exclusive jurisdiction of the courts in Kosovo.
         </p>
   
         <h4 style={{...headerTextStyle}}>9. Severability</h4>
         <p style={{...contentTextStyle}}>
           If any provision of this Agreement is deemed invalid, illegal, or unenforceable, the remaining provisions shall remain in full force and effect.
         </p>
   
         <p style={{...contentTextStyle}}>
           By using the Platform, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
         </p>
       </div>
     );
   
     /* ---------- German ---------- */
     const textDe = (
       <div style={{ ...textStyles, textAlign: "justify", padding: "20px" }}>
         <h1 style={{ textAlign: "left", marginBottom: "30px", fontWeight: "600" }}>
           Allgemeine Geschäftsbedingungen für den Online-Verkauf von Flügen und Hotels
         </h1>
   
         <p style={{...contentTextStyle}}>
           Diese Allgemeinen Geschäftsbedingungen (die "Vereinbarung") regeln den Kauf und die Nutzung von Flug- und Hoteldienstleistungen über FluturoLire L.L.C. ("der Verkäufer", "wir", "uns") über unsere Website und mobile Anwendung (zusammenfassend die "Plattform"). Durch den Zugriff auf oder die Nutzung der Plattform erklären Sie sich mit dieser Vereinbarung und unserer Datenschutzrichtlinie einverstanden.
         </p>
   
         <h4 style={{...headerTextStyle}}>{t("Company Information")}</h4>
         <p style={{...contentTextStyle}}>
           FluturoLire L.L.C.<br />
           Handelsregisternummer: 812101236<br />
           Eingetragene Adresse: Bedri Berisha Nr.51 Prishtinë<br />
           Kontakt-E-Mail: info@fluturolire.com
         </p>
   
         <h4 style={{...headerTextStyle}}>1. Buchung und Zahlung</h4>
         <h5 style={{...headerTextStyle}}>1.1 Reisebuchungen</h5>
         <p style={{...contentTextStyle}}>
           Die Plattform ermöglicht es Ihnen, Flüge und Hotels zu suchen, zu vergleichen und zu buchen. Alle Buchungen unterliegen der Verfügbarkeit und den Bedingungen der jeweiligen Fluggesellschaften, Hotels oder Dienstleister.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.2 Preise und Zahlung</h5>
         <p style={{...contentTextStyle}}>
           Alle Preise verstehen sich in Euro (€), beinhalten anwendbare Steuern und Gebühren, sofern nicht anders angegeben, und können sich jederzeit ändern. Mit der Buchung ermächtigen Sie FluturoLire L.L.C., die vollständige Zahlung über Ihre ausgewählte Zahlungsmethode einzuziehen.
         </p>
   
         <h5 style={{...headerTextStyle}}>1.3 Stornierungen, Änderungen und Rückerstattungen</h5>
         <p style={{...contentTextStyle}}>
           Stornierungs- und Erstattungsrichtlinien variieren je nach Anbieter. Einige Buchungen sind nicht erstattungsfähig oder mit Gebühren verbunden. FluturoLire hilft Ihnen bei der Bearbeitung Ihrer Anfrage. Eine Servicegebühr von FluturoLire kann zusätzlich zu den Gebühren des Anbieters anfallen.
         </p>
   
         <h4 style={{...headerTextStyle}}>2. Reisedokumente und Anforderungen</h4>
         <h5 style={{...headerTextStyle}}>2.1 Reisedokumente</h5>
         <p style={{...contentTextStyle}}>
           Sie sind verantwortlich für gültige Reisedokumente (Reisepass, Visum, Gesundheitsnachweise usw.). Wir haften nicht für verweigertes Boarding oder Einreiseprobleme.
         </p>
   
         <h5 style={{...headerTextStyle}}>2.2 Reisedaten</h5>
         <p style={{...contentTextStyle}}>
           Sie müssen vollständige und korrekte Angaben machen. Fehlerhafte Informationen können zu Zusatzkosten oder Reiseverweigerung führen.
         </p>
   
         <h4 style={{...headerTextStyle}}>3. Nutzungsverhalten</h4>
         <h5 style={{...headerTextStyle}}>3.1 Verbotene Aktivitäten</h5>
         <p style={{...contentTextStyle}}>
           Es ist untersagt:<br />
           • Die Plattform für illegale Zwecke zu nutzen<br />
           • Sicherheitsmechanismen zu umgehen<br />
           • Schadsoftware oder Viren hochzuladen<br />
           • Unbefugten Zugriff zu versuchen
         </p>
   
         <h5 style={{...headerTextStyle}}>3.2 Reisehinweise</h5>
         <p style={{...contentTextStyle}}>
           Sie sind selbst verantwortlich für die Beachtung von Reisebeschränkungen und staatlichen Hinweisen. Wir haften nicht für Verstöße.
         </p>
   
         <h4 style={{...headerTextStyle}}>4. Haftungsbeschränkung</h4>
         <h5 style={{...headerTextStyle}}>4.1 Haftungsausschluss</h5>
         <p style={{...contentTextStyle}}>
           FluturoLire handelt ausschließlich als Vermittler und haftet nicht für Angaben, die von Drittanbietern bereitgestellt werden.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.2 Freistellung</h5>
         <p style={{...contentTextStyle}}>
           Sie stellen FluturoLire von jeglichen Ansprüchen Dritter frei, die durch Ihre Nutzung der Plattform entstehen.
         </p>
   
         <h5 style={{...headerTextStyle}}>4.3 Haftungsgrenze</h5>
         <p style={{...contentTextStyle}}>
           Wir haften nicht für indirekte Schäden wie entgangenen Gewinn oder Datenverlust.
         </p>
   
         <h4 style={{...headerTextStyle}}>5. Höhere Gewalt</h4>
         <p style={{...contentTextStyle}}>
           Wir haften nicht für Ereignisse außerhalb unserer Kontrolle wie Naturkatastrophen, Pandemien, Streiks oder politische Unruhen.
         </p>
   
         <h4 style={{...headerTextStyle}}>6. Kündigung</h4>
         <p style={{...contentTextStyle}}>
           Wir können Ihr Konto jederzeit kündigen. Sie können uns ebenfalls unter support@fluturolire.com kontaktieren, um Ihr Konto zu löschen.
         </p>
   
         <h4 style={{...headerTextStyle}}>7. Änderungen</h4>
         <p style={{...contentTextStyle}}>
           Wir behalten uns das Recht vor, diese Bedingungen jederzeit zu ändern. Die fortgesetzte Nutzung bedeutet Ihre Zustimmung.
         </p>
   
         <h4 style={{...headerTextStyle}}>8. Anwendbares Recht</h4>
         <p style={{...contentTextStyle}}>
           Diese Vereinbarung unterliegt dem Recht der Republik Kosovo. Gerichtsstand ist Kosovo.
         </p>
   
         <h4 style={{...headerTextStyle}}>9. Salvatorische Klausel</h4>
         <p style={{...contentTextStyle}}>
           Sollten einzelne Bestimmungen ungültig sein, bleibt der Rest gültig.
         </p>
   
         <p style={{...contentTextStyle}}>
           Durch die Nutzung der Plattform akzeptieren Sie diese Bedingungen.
         </p>
       </div>
     );
   
     /* ===============================================================
        Render
        ===============================================================*/
     return (
       <div>
         <Styles />
         <Header translation={t} translationContext={{ t, i18n }} />
         <Banner showSearchBar={false} minHeight={isMobile ? "120px" : "300px"} translation={t} />
   
         <Content
           currentLang={currentLang}
           textAl={textAl}
           textEn={textEn}
           textDe={textDe}
         />
   
         <Footer />
         <Copyrights />
       </div>
     );
   };
   
   /* =================================================================
      Content section helper
      =================================================================*/
   const Content = ({ currentLang, textAl, textEn, textDe }) => (
     <Fragment>
       <section
         className="content"
         style={{ padding: isMobile ? 0 : "95px 0 0 0" }} /* top pad only */
       >
         <div className="container-fluid">
           <div className="row">
             <div
               className="col-12 mx-auto whitebox"
               style={{ maxWidth: "1400px" }} /* adjust/remove if needed */
             >
               {currentLang === "al"
                 ? textAl
                 : currentLang === "de"
                 ? textDe
                 : textEn}
             </div>
           </div>
         </div>
       </section>
     </Fragment>
   );
   
   export default TermsAndConditionsPage;
   